import React, { useState, useCallback } from "react";
import { BlockEditProps } from "@wordpress/blocks";
import type { BlockAttributes } from "./block.json";
import { useBlockProps } from "@wordpress/block-editor";

export default function FormEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "" });

  return (
    <>
      <div {...blockProps}>
        <div className="d-flex justify-content-center py-5">
          <div className="form-container white">
            <div className="row">
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  [text* nachname id:nachname class:form-control placeholder
                  "Nachname"]
                  <label htmlFor="nachname">Nachname*</label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  [text* vorname id:vorname class:form-control placeholder
                  "Vorname"]
                  <label htmlFor="vorname">Vorname*</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="geschlecht">Geschlecht</label>
                [select geschlecht id:geschlecht class:form-select
                class:form-control "männlich" "weiblich" "divers"]
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="geburtsdatum">Geburtsdatum*</label>
                [date* geburtsdatum id:geburtsdatum class:form-control
                placeholder "Geburtsdatum"]
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  [email* email id:email class:form-control placeholder
                  "Email-Adresse"]
                  <label htmlFor="email">Email-Adresse*</label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  [tel telefonnummer id:telefonnummer class:form-control
                  placeholder "Telefonnummer"]
                  <label htmlFor="telefonnummer">Telefonnummer</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="position">Position*</label>
                [select* position id:position class:form-select
                class:form-control "Social Media Experte" "Kauffrau /-mann für
                Büromanagement" "Hotelfachfrau /-mann" "Veranstaltungskauffrau
                /-mann" "Duales Studium"]
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="einstiegspunkt">Möglicher Einstiegspunkt</label>
                [date einstiegspunkt id:einstiegspunkt class:form-control
                placeholder "Möglicher Einstiegspunkt"]
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  [number gehaltsvorstellung id:gehaltsvorstellung
                  class:form-control placeholder "Gehaltsvorstellung"]
                  <label htmlFor="gehaltsvorstellung">Gehaltsvorstellung</label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-floating mb-3">
                  [number wochenstunden id:wochenstunden class:form-control
                  placeholder "Wochenstunden"]
                  <label htmlFor="wochenstunden">Wochenstunden</label>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="datei-upload" className="form-label">
                Datei hochladen
              </label>
              [file datei-upload id:datei-upload class:form-control limit:10mb
              filetypes:/*]
            </div>
            [submit class:button class:align-self-end "Absenden"]
          </div>
        </div>
      </div>
    </>
  );
}
